export const categories = [
  "全部",
  "娱乐热点",
  "科技互联网",
  "商业财经",
  "社会民生",
  "直播电商",
  "文化综艺",
] as const;

export type Category = (typeof categories)[number];

export interface EventStep {
  date: string;
  title: string;
  text: string;
}

export interface GuaEvent {
  id: string;
  title: string;
  category: Category;
  rank: number;
  updated: string;
  status: "已收束" | "发酵中" | "进行中" | "待定论";
  heat: number;
  tags: string[];
  summary: string;
  cause: string;
  steps: EventStep[];
  result: string;
  featured?: boolean;
}

export const hotEvents: GuaEvent[] = [
  {
    id: "ev-001",
    title: "某头部带货主播“批次混卖”翻车风波",
    category: "娱乐热点",
    rank: 1,
    updated: "09-06 14:20",
    status: "发酵中",
    heat: 98,
    tags: ["直播带货", "样品造假", "品牌回应"],
    summary: "有博主对比同一品牌两批到货商品发现明显差异，怀疑直播“样品与实物不符”，事件从质检对比一路烧到头部主播与品牌方的公开回应。",
    cause: "起初是几位消费者在社交平台晒出同款商品的两批差异对比，指出到货批次与直播间展示样品在用料、包装上明显不同，随后形成话题标签并快速扩散。",
    steps: [
      { date: "08-28", title: "第一支对比视频发出", text: "消费者博主发布两批商品细节对比，指出样品与实货用料存在差异，播放量数小时内冲上热门。" },
      { date: "08-30", title: "品牌方先行回应", text: "涉事品牌先发声明称批次差异属于正常供应链波动，未直接回应“样品”质疑。" },
      { date: "09-02", title: "主播直播回应争议", text: "头部主播在直播中说明供应链流程，并承诺开放第三方检测，但解释细节仍引发二次讨论。" },
      { date: "09-06", title: "检测与退货进展中", text: "平台与品牌陆续公布送检进度，消费者要求统一口径与补偿方案，事件仍在持续发酵。" },
    ],
    result: "事件尚未定论，正处于“品牌检测 + 平台介入 + 主播回应”多方博弈阶段，我们持续跟进补充节点。",
    featured: true,
  },
  {
    id: "ev-002",
    title: "某大厂“深度服务”强制开关遭整改",
    category: "科技互联网",
    rank: 2,
    updated: "09-05 18:40",
    status: "已收束",
    heat: 82,
    tags: ["隐私争议", "功能整改", "监管约谈"],
    summary: "某互联网大厂上线的新功能被指默认开启、收集路径不透明，用户在持续投诉后被要求整改，最终更新版本主动明示开关并给出解释。",
    cause: "新版本功能被用户发现未经明确同意即默认开启，隐私设置路径藏得较深，相关讨论与投诉在短时间内集中爆发。",
    steps: [
      { date: "08-20", title: "用户发现默认开启", text: "多位用户在更新版本后发现新功能默认启用，隐私说明需手动展开才能看到。" },
      { date: "08-24", title: "话题持续升温", text: "媒体与用户讨论聚焦“知情同意”与设置透明，相关话题登上多平台热搜。" },
      { date: "08-29", title: "厂商致歉并承诺整改", text: "厂商发布说明承认引导不够清晰，致歉并公布整改时间表。" },
      { date: "09-04", title: "新版本默认关闭", text: "更新版本改为默认关闭并在首次进入时弹出明确说明，事件基本收束。" },
    ],
    result: "厂商已完成功能整改并向用户致歉，该事件在官方给出明确方案后基本平息，处于“已收束”状态。",
  },
  {
    id: "ev-003",
    title: "某连锁咖啡品牌联名杯“一杯难求”",
    category: "商业财经",
    rank: 3,
    updated: "09-06 10:05",
    status: "发酵中",
    heat: 76,
    tags: ["联名营销", "黄牛炒价", "门店缺货"],
    summary: "一次跨界联名把限定杯、周边带成“硬通货”，门店大排长队、第三方转卖价翻数倍，也把话题推向“买咖啡还是买周边”的讨论。",
    cause: "联名款上架首日即被抢空，多个城市门店出现囤货与高价转卖，社交平台上“求购”“晒单”“吐槽排队”三类内容同时刷屏。",
    steps: [
      { date: "09-01", title: "联名官宣预热", text: "品牌提前放出联名预告与限量海报，粉丝与路人讨论度同步上涨。" },
      { date: "09-03", title: "首日开售即售罄", text: "限量杯与周边上架后多地门店数小时内售罄，第三方平台迅速出现加价链接。" },
      { date: "09-05", title: "黄牛炒价引热议", text: "转卖价格翻数倍冲上话题，有门店出台“限购”“验码取货”等临时规则。" },
      { date: "09-06", title: "官方补货计划中", text: "品牌宣布将分批补货并提醒理性消费，事件热度仍在延续。" },
    ],
    result: "官方正在分批补货并引导理性消费，事件处于“发酵中”，后续补货与价格回落情况我们会继续记录。",
    featured: true,
  },
  {
    id: "ev-004",
    title: "某景区“天价寄存”收费争议",
    category: "社会民生",
    rank: 4,
    updated: "09-04 16:30",
    status: "已收束",
    heat: 71,
    tags: ["景区服务", "明码标价", "市场监管"],
    summary: "有游客反映在某景区寄存行李被收取高额费用，质疑收费依据与透明度，最终当地市场监管部门介入并推动整改与退费。",
    cause: "游客在网络晒出寄存收费单，认为金额与存放时间明显不符且未提前充分告知，引发对“节假日隐性加价”的普遍共情。",
    steps: [
      { date: "08-26", title: "游客晒单质疑", text: "涉事游客发文晒出寄存收费明细，质疑价格缺乏公示与依据。" },
      { date: "08-28", title: "主管部门关注", text: "当地市场监管与文旅部门表示已介入了解，相关词条登上本地热搜。" },
      { date: "08-31", title: "约谈并推动整改", text: "主管部门约谈运营方，要求明确公示计价规则并对争议订单进行退费处理。" },
      { date: "09-03", title: "整改措施落地", text: "景区更新寄存价目并增加醒目公示，事件在官方处理结果公布后基本平息。" },
    ],
    result: "当地主管部门推动运营方完成退费与价目公示，事件已收束，相关整改措施也已明确落地。",
  },
  {
    id: "ev-005",
    title: "某网红橱窗“样品与实货不符”集体投诉",
    category: "直播电商",
    rank: 5,
    updated: "09-05 20:15",
    status: "进行中",
    heat: 66,
    tags: ["橱窗选品", "集体维权", "平台仲裁"],
    summary: "一批消费者购买某网红橱窗商品后反馈实货与介绍明显不符，形成集体投诉，选品、审核与赔付责任成为焦点。",
    cause: "多位消费者反馈到货商品在材质、尺寸上与直播间描述存在差距，因人数较多逐渐形成集体投诉与组织化维权。",
    steps: [
      { date: "08-22", title: "首批差评集中出现", text: "商品评论区集中出现关于“与描述不符”的反馈，部分附有开箱对比。" },
      { date: "08-27", title: "形成集体投诉", text: "消费者通过平台渠道集中投诉，相关讨论进入公共视野。" },
      { date: "09-02", title: "主播发布选品说明", text: "当事网红回应称将复核选品与供应商资质，承诺对问题订单先行退赔。" },
      { date: "09-05", title: "平台介入仲裁中", text: "平台客服介入协调退款与运费争议，处理流程仍在进行。" },
    ],
    result: "平台与当事方正在推进退赔与选品复核，事件状态为“进行中”，赔付口径和最终责任界定尚待明确。",
  },
  {
    id: "ev-006",
    title: "某综艺选手“抢麦名场面”争议",
    category: "文化综艺",
    rank: 6,
    updated: "09-03 21:50",
    status: "发酵中",
    heat: 74,
    tags: ["综艺剪辑", "选手冲突", "节目回应"],
    summary: "一档综艺正片里两位选手同台抢话的画面被反复传播，剪辑语境与完整现场成为讨论核心，节目方随后放出多机位花絮。",
    cause: "正片播出后，一段带有情绪张力的同台画面被截取传播，剪辑是否有引导性、现场真实经过如何成为争议焦点。",
    steps: [
      { date: "08-29", title: "正片播出引爆讨论", text: "节目中一段同台画面播出后迅速成为话题，正反观点激烈对立。" },
      { date: "09-01", title: "选手双方先后发声", text: "两位选手相继发文说明现场情况，描述存在出入，讨论进一步升温。" },
      { date: "09-03", title: "节目方放送花絮", text: "节目组放出未剪辑的多机位花絮，试图还原现场语境，观众解读仍存分歧。" },
    ],
    result: "节目方以多机位素材回应但观众解读仍存在分歧，事件处于“发酵中”，是否定论取决于后续素材与回应。",
  },
  {
    id: "ev-007",
    title: "某App“默认勾选扣费”遭集中投诉",
    category: "科技互联网",
    rank: 7,
    updated: "09-02 15:00",
    status: "已收束",
    heat: 63,
    tags: ["自动续费", "消费者权益", "应用商店"],
    summary: "某工具类App被指在开通页面默认勾选自动续费且取消入口隐蔽，遭大批用户投诉后完成版本修正并上线退款指引。",
    cause: "用户在应用商店评论区集中反映“稀里糊涂被扣费”，指向开通页面的默认勾选与隐藏的取消路径。",
    steps: [
      { date: "08-18", title: "评论区集中炸响", text: "应用商店内出现大量关于自动扣费的差评与追问。" },
      { date: "08-23", title: "媒体报道放大", text: "相关事件被媒体总结报道，“默认勾选”成关键质疑点。" },
      { date: "08-28", title: "厂商版本修正", text: "厂商更新版本，改为手动勾选并增加首月提醒弹窗。" },
      { date: "09-01", title: "开通退款指引", text: "厂商上线自助退款渠道并对近三个月争议订单集中核查。" },
    ],
    result: "厂商完成版本修正并上线退款指引，事件处于“已收束”，整体解决路径已清晰。",
  },
  {
    id: "ev-008",
    title: "某社区团购“临期食品”标注不清引热议",
    category: "社会民生",
    rank: 8,
    updated: "09-06 09:30",
    status: "发酵中",
    heat: 69,
    tags: ["临期食品", "团购平台", "食品安全"],
    summary: "有用户发现团购平台把临近保质期商品与常规商品混在一起售卖且页面标注不醒目，引发对“临期不等于过期、但要如实告知”的讨论。",
    cause: "用户在收到订单后才发现部分商品临近保质期，回头查看页面发现临期标识字号小、不易察觉，遂公开质疑平台告知义务。",
    steps: [
      { date: "09-04", title: "用户发帖质疑", text: "用户晒出订单与临期食品，指出页面标识不醒目、下单前几乎无法注意到。" },
      { date: "09-05", title: "平台回应说明", text: "平台表示将加强临期分类与提示，并说明可按规则申请售后。" },
      { date: "09-06", title: "页面优化推进中", text: "平台陆续优化临期商品的页面标签与筛选入口，具体落地范围仍待观察。" },
    ],
    result: "平台已开始优化临期提示，事件处于“发酵中”，优化落地与执行一致性仍需后续跟踪。",
  },
  {
    id: "ev-009",
    title: "某文化栏目“错别字字幕”翻车与道歉",
    category: "文化综艺",
    rank: 9,
    updated: "09-01 11:10",
    status: "已收束",
    heat: 58,
    tags: ["字幕差错", "文化栏目", "公开致歉"],
    summary: "一档以考据见长的文化栏目在字幕中把常见用字写错，被细心的观众当场指出，节目组快速更正并向考据观众致谢。",
    cause: "有观众在节目字幕中连续发现个别常见字的写法错误，截图发到讨论区，因栏目“严谨”人设形成反差而扩散。",
    steps: [
      { date: "08-30", title: "观众指出错字", text: "观众在讨论区贴出字幕截图，指出个别用字存在差错。" },
      { date: "08-31", title: "讨论登榜", text: "“栏目出错字”相关话题被转发，节目严谨人设受到调侃。" },
      { date: "09-01", title: "节目组更正致谢", text: "栏目组发布更正公告并致谢观众纠错，承诺加强校对，事件快速收束。" },
    ],
    result: "节目组完成更正并向观众致谢，事件属“已收束”，回应得体且及时。",
  },
];